import { render } from "./CustomNotes.vue?vue&type=template&id=ae4ad114&scoped=true&lang=pug"
import script from "./CustomNotes.vue?vue&type=script&lang=js"
export * from "./CustomNotes.vue?vue&type=script&lang=js"

import "./CustomNotes.vue?vue&type=style&index=0&id=ae4ad114&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4ad114"]])

export default __exports__